'use client';

import { type PropsWithChildren, Suspense, useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider as EQIThemeProvider } from '@eqi-investimentos/react';
import { queryClient } from '@/config/queryClient';
import { AuthProvider } from '@/contexts/AuthContext';
import { ConfigProvider } from '@/contexts/ConfigContext';
import { InvestProvider } from '@/contexts/InvestContext';
import { ModalUnauthenticated } from '@/components/molecules/ModalUnauthenticated';
import { Aeonik } from '../themes/fonts';
const ClientRootProvider = ({
  children
}: PropsWithChildren) => {
  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles?.parentElement) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);
  return <EQIThemeProvider fontFamily={Aeonik.style.fontFamily} data-sentry-element="EQIThemeProvider" data-sentry-component="ClientRootProvider" data-sentry-source-file="_rootProviders.tsx">
      <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-source-file="_rootProviders.tsx">
        <ConfigProvider data-sentry-element="ConfigProvider" data-sentry-source-file="_rootProviders.tsx">
          <Suspense data-sentry-element="Suspense" data-sentry-source-file="_rootProviders.tsx">
            <AuthProvider data-sentry-element="AuthProvider" data-sentry-source-file="_rootProviders.tsx">
              <InvestProvider data-sentry-element="InvestProvider" data-sentry-source-file="_rootProviders.tsx">
                {children}
                <ReactQueryDevtools initialIsOpen={false} data-sentry-element="ReactQueryDevtools" data-sentry-source-file="_rootProviders.tsx" />
                <ModalUnauthenticated data-sentry-element="ModalUnauthenticated" data-sentry-source-file="_rootProviders.tsx" />
              </InvestProvider>
            </AuthProvider>
          </Suspense>
        </ConfigProvider>
      </QueryClientProvider>
    </EQIThemeProvider>;
};
export default ClientRootProvider;